<template>
  <div>
    <div v-if="typeBlock==='sub-course' && cardList.length>0">
      <slot></slot>
      <div class="list sub-card-list">
        <div v-for="item in cardList" :key="item.courseId">

          <div class="rounded bg-white pt-3 pb-4 px-12p mb-20 position-relative" v-if="item.course.id">
            <img v-if="item.mustSelected" class="must-icon position-absolute top-0 right-0"
                 src="/static/img/index/must_learn.png" alt="">
            <p @click="goToPage(item)"
               class="mb-20 c-title-h van-multi-ellipsis--l2 line-18 ">
              {{item.course.title}}
            </p>
            <van-card class="p-0 card-row course-item mt-0">
              <template #title>
                <div class="line-14 font-12 color-33 mb-12 d-flex align-items-center justify-content-between"
                     v-if="item.course">
                 <p class="mb-0 van-ellipsis">{{item.course.summary}}</p>
<!--                  <div class="d-flex align-items-center ml-auto btns" @click="onSelect(item)">-->
<!--                    <svg t="1592303377722" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"-->
<!--                         p-id="2622" width="16" height="16" class="icon">-->
<!--                      <path-->
<!--                        d="M592 803c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z m-1e-8-291c0 44.183-35.817 80-79.99999999 79.99999999s-80-35.817-79.99999999-79.99999999 35.817-80 79.99999999-79.99999999 80 35.817 79.99999999 79.99999999z m1e-8-291c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z"-->
<!--                        p-id="2623"></path>-->
<!--                    </svg>-->
<!--                  </div>-->
                </div>
              </template>

              <template #tags>
                <div class="d-flex align-items-center" v-if="item.tags && item.tags.length>0">
                  <div class="tags-background font-10 color-66 mr-2 px-2"
                       v-for="(v,i) of item.tags" :key="i">
                    {{v}}
                  </div>
                </div>
              </template>
              <template #thumb>
                <img class="sub-card-img" v-if="item.course && item.course.coverUrl"
                     :src="uploadresUrl + item.course.coverUrl" alt="">
              </template>
              <template #footer>
                <div class="d-flex jindu mt-2 align-items-center color-88">
                  <div class="mr-2 d-flex align-items-center justify-content-between color-33"
                       style="flex: 0 0 5.25rem" v-if="item.userCourse">
                    <van-progress class="progress2 mr-2 w-100"
                                  :percentage="(item.learnedCnt/item.totalCnt)*100" stroke-width="4"/>
                    {{item.courseRate?item.courseRate:0|calcMoney}}%
                  </div>
                  <div v-else class="mr-2 d-flex align-items-center justify-content-between color-33"
                  style="flex: 0 0 5.25rem" >
                    <van-progress class="progress2 mr-2 w-100" percentage="0" stroke-width="4"/>
                  </div>
                  已学
                  <span
                    class="text-warning">{{(item.userCourse&&item.userCourse.progress)?item.userCourse.progress:0}}</span>小节/共{{item.course && item.course.statInfo
                  &&item.course.statInfo.mustLearnSessionCount?item.course.statInfo.mustLearnSessionCount:0}}小节
                  <span class="ml-auto" v-if="item.userCourse">{{ item.userCourse.lastLearnTime|dateFormat }}</span>
                </div>
              </template>
            </van-card>
          </div>
        </div>

      </div>
    </div>
    <div class="border-bottom pb-28 bg-white px-3" v-else
         :class="{'no-class': typeBlock==='zhuanlan'|| typeBlock==='zl_course'}">
      <slot></slot>
      <div class="list">
        <van-card class="p-0 card-row course-item"
                  :class="{'hasPrice-card': typeBlock==='lec_course'|| typeBlock==='lec_zhuanlan'}"
                  v-for="item in cardList" :key="item.id"
                  @click-thumb="toLink(item)">
          <template #title>
            <div class="c-title van-multi-ellipsis--l2 line-18" @click="toLink(item)">
              {{item.title}}
            </div>
          </template>
          <template #desc>
            <p class="c-desc van-ellipsis line-12" :class="{'mb-26': typeBlock==='course'}">
              {{item.desc}}
            </p>
          </template>
          <template #thumb>
            <img class="van-card-img" :src="item.image" alt="">
          </template>

          <template #origin-price>
            <div class="" v-if="typeBlock==='lec_course' || typeBlock==='lec_zhuanlan'">
              <span class="">¥ {{item.oldPrice}}</span>
            </div>
          </template>

          <template #price>
            <div class="" v-if="typeBlock==='lec_course' || typeBlock==='lec_zhuanlan'">
              <span class="price">¥ {{item.price}}</span>
            </div>
<!--            <p v-if="typeBlock==='zhuanlan'" class="d-flex align-items-center mb-0">-->
<!--              <router-link tag="span" class="font-13 color-88" :to="{name: 'Lecturer' ,params: {uid: item.id}}">-->
<!--                <span v-if="typeBlock==='zhuanlan'">讲师：</span>{{item.author}}-->
<!--              </router-link>-->
<!--            </p>-->
            <p class="mb-0 ava-add-list d-flex flex-row-reverse" v-if="typeBlock==='course'">
              <img class="c-avatar23 ava-add" src="/static/img/pro/more.png" alt="">
              <img class="c-avatar23 ava-add" :src="item.avatar" alt="">
            </p>

          </template>
          <template #tags v-if="typeBlock==='lec_course' || typeBlock==='lec_zhuanlan'||typeBlock==='zl_course' ">
            <div class="position-absolute tags-background font-10 color-88">直播车</div>
          </template>
          <!--          <template #num>
                      &lt;!&ndash;<router-link v-if="typeBlock==='course'" :to="{name: 'indexCourse', params: {id: item.id}}"&ndash;&gt;
                      &lt;!&ndash;class="primary-bton" href="course-home.html">&ndash;&gt;
                      &lt;!&ndash;{{item.progress===0?'进入学习':item.progress===100?'查看学习':'继续学习'}}&ndash;&gt;
                      &lt;!&ndash;</router-link>&ndash;&gt;
                      <p class="mb-0 color-88 font-10" v-if="typeBlock==='course'||typeBlock==='zl_course'">
                        16563人参与
                      </p>
                      <div class="share-butn" v-if="typeBlock==='zhuanlan'" @click="onSelect">
                        <svg class="bi bi-box-arrow-up-right" width="1em" height="1em" viewBox="0 0 16 16"
                             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path class="text-white" fill-rule="evenodd"
                                d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"
                                clip-rule="evenodd"/>
                          <path class="text-white" fill-rule="evenodd"
                                d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"
                                clip-rule="evenodd"/>
                        </svg>
                        分享
                      </div>
                    </template>-->
          <template #footer>
            <div class="d-flex jindu mt-2 align-items-center" v-if="typeBlock==='course'">
              <div class="mr-2 d-flex align-items-center justify-content-between"
                   style="flex: 0 0 7.5rem">
                <van-progress class="progress2 mr-2 w-100" :percentage="item.progress?item.progress:0"
                              stroke-width="4"/>
                {{item.progress}}%
              </div>
              {{item.barNum}}小节
              <span class="mx-1">|</span>2020-5-11 10:38 最后时间
            </div>
          </template>
        </van-card>
      </div>
    </div>
  </div>


</template>

<script>
  import Vue from 'vue';
  import {Loading, Progress} from 'vant';
  import {Icon} from 'vant';
  import {Card} from 'vant';

  Vue.use(Card);
  Vue.use(Icon);
  Vue.use(Progress);
  Vue.use(Loading);
  import {mapState} from "vuex";

  export default {
    name: "rowCardComponent",
    data() {
      return {
        pageType: '',
        showShare: false,
        shareObj: {},
        proObj: {},
        type: '',
        proLearningStartTime: 0,
        proLearningEndTime: 0,
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl
      })
    },
    components: {

    },
    props: [
      'typeBlock',
      'cardList',
      'proTimeObj'
    ],
    created() {
      this.proObj = this.proTimeObj;
      if (this.proObj && this.proObj.proLearningStartTime) {
        this.proLearningStartTime = this.proObj.proLearningStartTime;
      }

      if (this.proObj && this.proObj.proLearningEndTime) {
        this.proLearningEndTime = this.proObj.proLearningEndTime;
      }

      this.type = this.typeBlock;
    },
    methods: {
      goToPage(item) {
        let nowTime = new Date().getTime();
        // 只要拥有这个课就可以进入课程学习页面，但是超出项目时间不记录学时
        if (nowTime >= this.proLearningStartTime) {
          this.$router.push({ name: 'indexCourse',
            params: { id:  item.courseId}, query: {proId: item.projectId, proName: this.proTimeObj.proName}});
        } else {
          this.$toast('该课程暂未开放学习！')
        }
      },
      toLink(e) {
        this.pageType = this.typeBlock;
        if (this.typeBlock.indexOf('_') > -1) {
          this.pageType = this.typeBlock.split('_')[1];
          if (this.typeBlock === 'lec_course') {
            this.pageType = 'course'
          } else if (this.typeBlock === 'zl_course') {
            //专栏或课程预售页的课程，暂不加链接
            return;
          }
        }
        this.$router.push('/' + this.pageType + '/' + e.id)
      },
      // onSelect(option) {
      //   this.shareObj = option;
      //   this.$router.push('/share-poster');
      // },

    }
  }
</script>
<style>
  .card-row .van-card__content {
    justify-content: space-between;
  }
  .no-class {
    border-bottom: none !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 0 !important;
  }

  .sub-card-list .card-row .van-card__thumb {
    width: 5.3125rem;
    height: 3rem;
    overflow: hidden;
    border-radius: .25rem !important;
    margin-right: .625rem;
  }

  .sub-card-list .card-row .van-card__content {
    min-height: 2rem !important;
  }

  .sub-card-img {
    width: 5.3125rem;
    height: 3rem;
    overflow: hidden;
    border-radius: .25rem !important;
  }

  .sub-card-list .btns {
    top: .75rem;
    right: 0;
  }
</style>
